/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Traces_DescriptionInputs */

const es_admin_traces_description = /** @type {(inputs: Admin_Traces_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitorea la actividad del sistema.`)
};

const en_admin_traces_description = /** @type {(inputs: Admin_Traces_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitor system activity.`)
};

/**
* | output |
* | --- |
* | "Monitor system activity." |
*
* @param {Admin_Traces_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_traces_description = /** @type {((inputs?: Admin_Traces_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Traces_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_traces_description(inputs)
	return en_admin_traces_description(inputs)
});
export { admin_traces_description as "admin.traces.description" }